import { push } from 'react-router-redux'

import createConstant from '../../utils/createConst'
import { API_HOSTNAME } from '../../GlobalConfig'

const SEARCH_TYPE = createConstant('main/SEARCH_TYPE')
// const OPENMODAL_REQUESTED = 'main/OPENMODAL_REQUESTED'
const OPENMODAL = 'main/OPENMODAL'
const TOGGLEPROMPT = 'main/TOGGLEPROMPT'
const CHANGE_POPUP = 'main/CHANGE_POPUP'
const REGISTER_SUCCESS = 'user/REGISTER_SUCCESS'
const LOGIN_SUCCESS = 'user/LOGIN_SUCCESS'
const SEND_OTP_SUCCESS = 'user/SEND_OTP_SUCCESS'
const SEND_CHAT_SUCCESS = 'inbox/SEND_CHAT_SUCCESS'
const SEND_CHAT_ERROR = 'inbox/SEND_CHAT_ERROR'
const REMOTE_NOTIF = 'main/REMOTE_NOTIF'
const SHOW_NEWS = createConstant('main/SHOW_NEWS')

const initialState = {
  modalIsOpen: false,
  promptIsOpen: false,
  popUp: 'login',
  searchTypeRequest: false,
  searchTypeError: '',
  searchType: undefined,
  notif: undefined,
  news: undefined,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case OPENMODAL:
      return {
        ...state,
        modalIsOpen: action.payload,
      }
    case TOGGLEPROMPT:
      return {
        ...state,
        promptIsOpen: action.payload,
      }
    case CHANGE_POPUP:
      return {
        ...state,
        popUp: action.payload,
      }
    case REGISTER_SUCCESS:
      return {
        ...state,
        popUp: 'otp',
      }
    case LOGIN_SUCCESS:
      if (action.result.status === 'not verified') {
        return {
          ...state,
          popUp: 'otp',
        }
      }
      return state
    case SEND_OTP_SUCCESS:
      return {
        ...state,
        popUp: 'thanks',
      }
    case SEARCH_TYPE.request:
      return {
        ...state,
        searchTypeRequest: true,
        searchTypeError: '',
      }
    case SEARCH_TYPE.failed:
      return {
        ...state,
        searchTypeRequest: false,
        searchTypeError: action.error.message,
        searchType: undefined,
      }
    case SEARCH_TYPE.success:
      return {
        ...state,
        searchTypeRequest: false,
        searchTypeError: '',
        searchType: action.result.result,
      }
    case SHOW_NEWS:
      return {
        ...state,
        news: action.result.value,
      }
    case REMOTE_NOTIF:
      return {
        ...state,
        notif: undefined,
      }
    case SEND_CHAT_SUCCESS:
      return {
        ...state,
        notif: {
          type: 'success',
          message: action.success.message,
        },
      }
    case SEND_CHAT_ERROR:
      return {
        ...state,
        notif: {
          type: 'error',
          message: action.error.message,
        },
      }
    default:
      return state
  }
}

export const openModal = payload => (dispatch) => {
  dispatch({
    type: OPENMODAL,
    payload,
  })
}

export const togglePrompt = payload => (dispatch) => {
  dispatch({
    type: TOGGLEPROMPT,
    payload,
  })
}

export const changePopup = payload => (dispatch) => {
  dispatch({
    type: CHANGE_POPUP,
    payload,
  })
}

export const getSearchType = query => (dispatch) => {
  let url = `${API_HOSTNAME}/v1/search/bar`

  if (query) {
    url += `?q=${query}`
  }

  dispatch({
    types: SEARCH_TYPE,
    promise: fetch(url),
  })
}

export const removeNotif = () => (dispatch) => {
  dispatch({
    type: REMOTE_NOTIF,
  })
}

export const showNews = () => (dispatch) => {
  const url = `${API_HOSTNAME}/v1/news`

  dispatch({
    types: SHOW_NEWS,
    promise: fetch(url),
  })
}

export const mobileNavigate = route => (dispatch) => {
  dispatch(push(route))
}



// WEBPACK FOOTER //
// ./src/modules/Main/index.js